module.exports = __webpack_public_path__ + "img/forgot-password-v2.4351c207.svg";